// extracted by mini-css-extract-plugin
export default {"root":"range-item_root__sFOHR","delButton":"range-item_delButton__d7b2I","inpItem":"range-item_inpItem__UUuOI","wrapInner":"range-item_wrapInner__dAtFf"};